<!-- Free Form Type Form -->
@if (slideAuthorFacade.currentSelectedSlideFreeFormTypeArray$ | async; as freeFormTypeArray) {
  @if (freeFormTypeForm && freeFormTypeArray && freeFormTypeArray.length > 0) {
    <medsurf-design-form-control-form
      [formGroup]="freeFormTypeForm"
      [class]="'w-full'"
      (onSubmit)="onSubmit()">
      <!-- Type -->
      <medsurf-design-form-control-input-dropdown [control]="freeFormTypeForm.controls.shape"
        [class]="'w-full'"
        [options]="freeFormTypeArray"
        [label]="'global.shape_type'"
      (valueChange)="onSubmit()"></medsurf-design-form-control-input-dropdown>
    </medsurf-design-form-control-form>
  }
}